import React from 'react'

/**
 * 小箭头 fill="#CFD8E1"
 */
export const ArrowDownIcon = (): JSX.Element => (
  <svg width="18" height="11" fill="currentColor">
    <g transform="rotate(180 9,5.500000000000001)">
      <polygon points="5.124438762664795,7.972818374633789 9.000001430511475,3.02718186378479 12.875561237335205,7.972818374633789"/>
    </g>
  </svg>
)
